import React from 'react';
import { useTranslation } from 'react-i18next';
import { SITE_URLS } from '@constants';
import { useSEOMetatags } from '@hooks/useSEOMetatags';
import { FiltersProvider } from '@context';
import { Dashboard } from '@components/templates/myAccount';

export function DashboardPage() {
    const { t } = useTranslation();

    const translations = {
        title: t('dashboard-component.metatags.title'),
        description: t('dashboard-component.metatags.description'),
    };

    useSEOMetatags({
        title: translations.title,
        description: translations.description,
        url: SITE_URLS.myDashboard,
        index: false,
    });

    return (
        <FiltersProvider>
            <Dashboard />
        </FiltersProvider>
    );
}
